import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { RumConfig } from "../constants/Rum";
import { ENV_STAGES } from "../constants/Stages";

export const awsRumConfig = () => {
  let awsRum: any;
  try {
    if (window.location.hostname === ENV_STAGES.PROD) {
      const config: AwsRumConfig = {
        sessionSampleRate: 1,
        guestRoleArn: RumConfig.GUEST_ROLE_ARN,
        identityPoolId: RumConfig.IDENTITY_POOL_ID,
        endpoint: RumConfig.END_POINT,
        telemetries: [
          "performance",
          "errors",
          ["http", { recordAllRequests: true }],
        ],
        allowCookies: true,
        enableXRay: false,
      };

      const APPLICATION_ID = RumConfig.APPLICATION_ID;
      const APPLICATION_VERSION = RumConfig.APPLICATION_VERSION;
      const APPLICATION_REGION = RumConfig.APPLICATION_REGION;

      return (awsRum = new AwsRum(
        APPLICATION_ID,
        APPLICATION_VERSION,
        APPLICATION_REGION,
        config
      ));
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

